import moment from "moment";
import { Fragment, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ButtonStandard from '../../utillityComponents/ButtonStandard';
import IsAuth from "../../utillityComponents/IsAuth";
import StatusStyles from "../../utillityComponents/StatusStyles";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const tabs = [
  { index: 1, name: 'Se Alle', slug: 'all'},
  { index: 2, name: 'Se Aktiveret', slug: 'active'},
  { index: 3, name: 'Se Deaktiveret', slug: 'deactive'},
]

export default function List(props) {
  const axiosPrivat = useAxiosPrivate();
  const statusStyles = StatusStyles()
  const [ users, setUsers ] = useState([]);
  const [ slug, setSlug ] = useState();

  // New UI state
  const [ view, setView ] = useState('cards') // 'table' | 'cards'
  const [ roleFilter, setRoleFilter ] = useState('alle') // 'alle' | role name
  const [ searchLocal, setSearchLocal ] = useState('')
  const [ expandedEvents, setExpandedEvents ] = useState(new Set())

  const toggleExpandedEvents = (id) => {
    setExpandedEvents((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }

  // Load persisted preferences
  useEffect(() => {
    const v = localStorage.getItem('users_view')
    const rf = localStorage.getItem('users_roleFilter')
    const s = localStorage.getItem('users_search')
    if (v) setView(v)
    if (rf) setRoleFilter(rf)
    if (s) setSearchLocal(s)
  }, [])

  // Persist preferences
  useEffect(() => { localStorage.setItem('users_view', view) }, [view])
  useEffect(() => { localStorage.setItem('users_roleFilter', roleFilter) }, [roleFilter])
  useEffect(() => { localStorage.setItem('users_search', searchLocal) }, [searchLocal])
  

  const masterGetUsers = async ( props ) => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async ( props ) => {
        try {
            var extention = '';

            if (props === 'all') {
              extention = '';
            }

            if (props === 'active') {
              extention = '?active=true';
            }

            if (props === 'deactive') {
              extention = '?active=false';
            }
            const response = await axiosPrivat.get('/user/all' + extention, {
                signal: controller.signal
            });
            //console.log(response.data);
            isMounted && setUsers(response.data);
            localStorage.setItem('user_list-current-page', props);
            setSlug(props);
        } catch (err) {
            console.error(err);
        }
        
    }

    getUsers( props );

    return () => {
        isMounted = false;
        controller.abort();
    }
  }


  useEffect(() => {
    masterGetUsers(localStorage.getItem('user_list-current-page') ? localStorage.getItem('user_list-current-page') : 'active');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getUsers = async ( props ) => {
    masterGetUsers(props);
  }

  // Derived lists for filters/search
  const allRoleNames = useMemo(() => users.map((r) => r.name), [users])
  const filteredByRole = useMemo(() => {
    if (roleFilter === 'alle') return users
    return users.filter((r) => r.name === roleFilter)
  }, [users, roleFilter])

  const filteredUsers = useMemo(() => {
    const q = (searchLocal || '').toLowerCase()
    return filteredByRole.map((role) => ({
      ...role,
      users: role.users.filter((u) => {
        if (!q) return true
        const inName = (u.name || '').toLowerCase().includes(q)
        const inEmail = (u.email || '').toLowerCase().includes(q)
        return inName || inEmail
      })
    })).filter((role) => role.users.length > 0)
  }, [filteredByRole, searchLocal])

  const renderEventChips = (events, userId) => {
    const slugs = (events || []).map((e) => e.slug)
    const isExpanded = expandedEvents.has(userId)
    const visible = isExpanded ? slugs : slugs.slice(0, 4)
    const remaining = slugs.length - visible.length
    return (
      <div className="flex flex-wrap gap-1.5 max-w-full">
        {visible.map((slug, idx) => (
          <span key={slug + idx} className="inline-flex items-center rounded-lg bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-200 px-2 py-1 text-xs font-medium text-indigo-700 shadow-sm">
            {slug}
          </span>
        ))}
        {remaining > 0 && (
          <button 
            type="button" 
            onClick={() => toggleExpandedEvents(userId)} 
            className="inline-flex items-center rounded-lg bg-gradient-to-r from-indigo-100 to-purple-100 border border-indigo-300 px-2 py-1 text-xs font-medium text-indigo-800 hover:from-indigo-200 hover:to-purple-200 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            +{remaining}
          </button>
        )}
        {isExpanded && slugs.length > 4 && (
          <button 
            type="button" 
            onClick={() => toggleExpandedEvents(userId)} 
            className="inline-flex items-center rounded-lg bg-gray-100 border border-gray-300 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
            </svg>
            Skjul
          </button>
        )}
      </div>
    )
  }

  return (
      <>
      <div className="px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-0">
    <h2 className="max-w-6xl mx-auto mt-8 px-4 text-lg leading-6 font-medium text-gray-900 sm:px-6 lg:px-8">
    {props.title}
  </h2>

    <div className="px-4 sm:px-6 lg:px-8">
      <div>
        <div className="sm:hidden">
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select
            id="tabs"
            name="tabs"
            onChange={(e) => getUsers(e.target.value)}
            className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
          >
            {tabs.map((tab) => (
              <option key={tab.index} value={tab.slug}>{tab.name}</option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <nav className="flex flex-wrap items-center gap-2" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.index}
                type="button"
                onClick= {() => getUsers(tab.slug)}
                className={classNames(
                  tab.slug === slug ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700',
                  'rounded-md px-3 py-2 text-sm font-medium'
                )}
                aria-current={tab.slug === slug ? 'page' : undefined}
              >
                {tab.name}
              </button>
            ))}

            {/* New controls */}
            <div className="ml-auto flex items-center gap-2">
              <div className="hidden sm:flex items-center gap-2">
                <label htmlFor="roleFilter" className="text-sm text-gray-700">Rolle</label>
                <select
                  id="roleFilter"
                  name="roleFilter"
                  value={roleFilter}
                  onChange={(e) => setRoleFilter(e.target.value)}
                  className="block w-44 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                >
                  <option value="alle">Alle roller</option>
                  {allRoleNames.map((r) => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </select>
              </div>
              <div className="hidden sm:flex items-center gap-2">
                <input
                  type="text"
                  placeholder="Søg navn eller email..."
                  value={searchLocal}
                  onChange={(e) => setSearchLocal(e.target.value)}
                  className="block w-56 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 text-sm px-3 py-2"
                />
              </div>
              <div className="inline-flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300">
                <button
                  type="button"
                  className={(view === 'table' ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-white text-gray-700 hover:bg-gray-50') + ' relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-medium focus:z-10'}
                  onClick={() => setView('table')}
                >
                  Tabel
                </button>
                <button
                  type="button"
                  className={(view === 'cards' ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-white text-gray-700 hover:bg-gray-50') + ' relative -ml-px inline-flex items-center rounded-r-md px-3 py-2 text-sm font-medium focus:z-10'}
                  onClick={() => setView('cards')}
                >
                  Kort
                </button>
              </div>
              {IsAuth(['Admin', 'Ngo', 'Org_admin', 'Event_admin']) ?
                <ButtonStandard text={'Opret bruger'} size="medium" click={props.openPopup} />
                : ''
              }
            </div>
          </nav>
        </div>
      </div>
      
      {/* Cards view */}
      {view === 'cards' ? (
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {filteredUsers.flatMap((role) => role.users.map((u) => {
            return (
            <div key={u.id} className="group relative bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-96 flex flex-col">
              {/* Status indicator bar */}
              <div className={`h-1 w-full ${u.is_activated ? 'bg-gradient-to-r from-green-400 to-emerald-500' : 'bg-gradient-to-r from-red-400 to-rose-500'}`}></div>
              
              {/* Online indicator - green line if logged in within last 4 hours */}
              {u.last_login && moment().diff(moment(u.last_login), 'hours') <= 4 && (
                <div className="h-0.5 w-full bg-gradient-to-r from-green-500 to-emerald-600"></div>
              )}
              
              {/* Card content */}
              <div className="px-6 pt-6 pb-4 flex flex-col flex-1">
                {/* Header with avatar and status */}
                <div className="mb-4">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center space-x-3 flex-1 min-w-0">
                      <div className="relative flex-shrink-0">
                        <div className={`h-12 w-12 rounded-xl ring-3 overflow-hidden bg-gradient-to-br from-indigo-100 to-purple-100 ${
                          u.last_login && moment().diff(moment(u.last_login), 'hours') <= 4 
                            ? 'ring-green-400' 
                            : 'ring-gray-100'
                        }`}>
                          <img 
                            className="h-full w-full object-cover" 
                            src={u.cloudflare_img_uuid ? process.env.REACT_APP_CLUDFLARE_IMG_BASE_URL + u.cloudflare_img_uuid + "/48x48" : process.env.REACT_APP_CLUDFLARE_DEFAULT_IMG_URL + "/48x48"} 
                            alt={u.name} 
                          />
                        </div>
                       
                        {/* Online indicator dot */}
                        {u.last_login && moment().diff(moment(u.last_login), 'hours') <= 4 && (
                          <div className="absolute -top-0.5 -right-0.5 h-3 w-3 bg-green-500 rounded-full ring-2 ring-white animate-pulse"></div>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-base font-semibold text-gray-900 truncate" title={u.name}>{u.name}</h3>
                        <p className="text-xs text-gray-500 truncate" title={u.email}>{u.email}</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${
                      u.is_activated 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      <div className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                        u.is_activated ? 'bg-green-400' : 'bg-red-400'
                      }`}></div>
                      {u.is_activated ? 'Aktiv' : 'Deaktiveret'}
                    </span>
                  </div>
                </div>

                {/* Role info */}
                <div className="mb-3">
                  <div className="flex items-center text-xs text-gray-600">
                    <svg className="w-3 h-3 mr-1.5 text-indigo-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span className="font-medium">Rolle:</span>
                    <span className="ml-1 text-gray-900 truncate" title={filteredUsers.find((r) => r.users.some((x) => x.id === u.id))?.name}>
                      {filteredUsers.find((r) => r.users.some((x) => x.id === u.id))?.name}
                    </span>
                  </div>
                </div>

                {/* Events */}
                <div className="mb-3 flex-1">
                  <div className="flex items-center text-xs text-gray-600 mb-1.5">
                    <svg className="w-3 h-3 mr-1.5 text-indigo-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="font-medium">Events:</span>
                  </div>
                  <div className="h-16 overflow-hidden">
                    {renderEventChips(u.events, u.id)}
                  </div>
                </div>

                {/* Last login */}
                <div className="mb-3 text-xs text-gray-500">
                  <div className="flex items-center">
                    <svg className="w-3 h-3 mr-1.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="truncate">
                      Sidst logget ind: {u.last_login ? moment(u.last_login).format('DD MMM HH:mm') : 'aldrig'}
                    </span>
                  </div>
                </div>

                {/* Action button */}
                <div className="pt-4 pb-2 border-t border-gray-100 mt-auto">
                  <Link 
                    to={'/user/edit/' + u.id} 
                    className="group/btn w-full inline-flex items-center justify-center px-4 py-2.5 bg-indigo-600 text-white text-sm font-semibold rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5"
                  >
                    <svg className="w-4 h-4 mr-2 group-hover/btn:rotate-12 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Rediger profil
                  </Link>
                </div>
              </div>
            </div>
          )}))}
        </div>
      ) : (
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full">
                <thead className="bg-white">
                  <tr>
                    <th>
                    </th>
                    <th scope="col" className="font-semibold whitespacepy-4 pl-0 pr-3 text-sm text-gray-900 sm:pl-3">
                      Navn
                    </th>
                    <th scope="col" className="font-semibold whitespacepy-4 pl-0 pr-3 text-sm text-gray-900 sm:pl-3">
                      Email
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Events
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Sidst logget ind
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                      Aktiveret
                    </th>
                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {filteredUsers.map((role) => (
                    <Fragment key={role.name}>
                      <tr className="border-t border-gray-200">
                        <th
                          colSpan={6}
                          scope="colgroup"
                          className="bg-gray-50 px-4 py-2 text-left text-sm font-semibold text-gray-900 sm:px-6"
                        >
                          {role.name}
                        </th>
                      </tr>
                      {role.users.sort((a, b) => a.first_name > b.first_name ? 1 : -1).map((users, eventsIdx) => {
                        return (
                        <tr
                          key={users.id}
                          className={classNames(eventsIdx === 0 ? 'border-gray-300' : 'border-gray-200', 'border-t')}
                        >
                          <td
                           className='py-2 block h-9 w-9 rounded-full ml-4 mr-3'
                          >
                          <img
                            className="block h-9 w-9 rounded-full ml-4"
                            src={users.cloudflare_img_uuid ? process.env.REACT_APP_CLUDFLARE_IMG_BASE_URL + users.cloudflare_img_uuid + "/36x36" : process.env.REACT_APP_CLUDFLARE_DEFAULT_IMG_URL + "/36x36"}
                            alt={users.name}
                          />
                          </td>
                          <td className="whitespacepy-4 pl-0 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                            {users.name}
                          </td>
                          <td className="whitespacepy-4 pl-0 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                            {users.email}
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500">
                            {renderEventChips(users.events, users.id)}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{users.last_login ? moment(users.last_login).format("dddd, DD MMM HH:mm YYYY") : 'aldrig'}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <span
                            className={classNames(
                              statusStyles[users.is_activated ? 'aktiv' : 'deaktiveret'],
                              'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize'
                            )}
                          >
                            {users.is_activated ? 'aktiv' : 'deaktiveret'}
                          </span>
                          </td>
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                            <Link to={'/user/edit/' + users.id} className="text-indigo-600 hover:text-indigo-900 float-right">
                                Edit<span className="sr-only">, {users.name}</span>
                            </Link>
                          </td>
                        </tr>
                      )})}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      )}
      </div>
      {/* Moved create button up into controls */}
    </div>
    </>
    )
  }
  
